import { BUTTON_VARIANTS } from 'components/common/Button'

/** Same as a regular button but without a "link" variant */
export const SPLIT_BUTTON_VARIANTS = {
  [BUTTON_VARIANTS.primary]: BUTTON_VARIANTS.primary,
  [BUTTON_VARIANTS.secondary]: BUTTON_VARIANTS.secondary,
}
